import { PropsWithChildren } from "react";
import { MessagingInboxListContainerStyled } from "../styles";

const MessagingInboxListContainer = ({ children }: PropsWithChildren) => (
  <MessagingInboxListContainerStyled item xs={12}>
    {children}
  </MessagingInboxListContainerStyled>
);

export default MessagingInboxListContainer;
